interface ZendeskWidgetHostElement extends HTMLElement {
    __zendeskWidgetHandler?: (event: Event) => void
}

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('zendesk-widget', {
        mounted(el: HTMLElement) {
            const host = el as ZendeskWidgetHostElement
            const { open } = useZendeskWidget()

            const handleClick = (event: Event) => {
                event.preventDefault()
                event.stopPropagation()
                open()
            }

            host.addEventListener('click', handleClick)
            host.__zendeskWidgetHandler = handleClick
        },
        unmounted(el: HTMLElement) {
            const host = el as ZendeskWidgetHostElement
            const handler = host.__zendeskWidgetHandler

            if (!handler) {
                return
            }

            host.removeEventListener('click', handler)
            delete host.__zendeskWidgetHandler
        },
    })
})
